// 00x-buybuttonmayflowersociety

function CurrentOrder() {
    $("p.order_size span").text(localStorage.Size);
    $("p.order_frame span").text(localStorage.Frame);
    $(".order_price span").text(localStorage.Price_Current);
    $("p.order_mapstyle span").text(localStorage.MapStyle);
    $("p.order_title span").text($("#title-line1").text());
    $("p.order_year span").text(localStorage.YearOfCrossing);
    $("p.order_region span").text(localStorage.originsTextBoxL1);
    $("p.order_Departure span").text(localStorage.Departure);
    $("p.order_Arrival span").text(localStorage.Arrival);
    $("p.order_Plaque span").text(localStorage.Origin);
    $("p.order_tailored span").text(localStorage.tailored);
}



$(document).ready(function () {
    
    // on load setup default frame
    var frameName = '';
    var TwoThree = localStorage.TwoThree;

    // console.log("frameName", localStorage.Frame);
    // console.log("TwoThree", TwoThree);
    // console.log("Size", localStorage.Size);

    if(localStorage.tailored == "Tailored"){
        localStorage.TwoThree = localStorage.UserTwoThree;
    };


    
    //console.log("localStorage.UserTwoThree", localStorage.UserTwoThree);
    //console.log("localStorage.Frame", localStorage.Frame);

     
    if ( localStorage.Frame != 'NoFrame') {
      //  console.log("localStorage.TwoThree --- ", localStorage.TwoThree);
        //console.log("not equal to no frame");
        // if localstorage.frame is not equal "NoFrame" add statement
        if (localStorage.TwoThree == "2DColorProfile"){

           // console.log("localStorage.TwoThree == '2DColorProfile'");
            // if localstorage "TwoThree" = 2D Colorprofile then Frame = FramedColorProfile
            frameName = "FramedColorProfile";
        } else if (localStorage.TwoThree == "3D") {
            // if localstorage "TwoThree" = 3D profile then Frame = framed 3d Profile
             frameName = "Framed3DProfile";
        } else {
            // if localstorage "TwoThree" = 2D heritage then Frame = FramedHeritage
            frameName = "FramedHeritage";
        }
    } else {
        // if localstorage.frame is equal "NoFrame" add statement 
        // and TwoThree = 2D color profile then frame = unframed color profile
        if (localStorage.TwoThree == "2DColorProfile"){
             frameName = "UnframedColorProfile";
        } else {
             frameName = "UnframedHeritage";
        }
    }
    
    var searchVariant = localStorage.Size + ' / ' + localStorage.tailored + ' / ' + frameName;
    //console.log("searchVariant custom.js", searchVariant);
    // console.log("allProductVariants", allProductVariants);
    //  console.log("allProductVariants[selected_variant", allProductVariants[searchVariant]);
    var variantCurrentPrice = allProductVariants[searchVariant].split(',')[1];
    var variantCurrentPriceFormated = `${USDollar.format(variantCurrentPrice/100)}`;
    localStorage.Price_Current = variantCurrentPriceFormated;

    // console.log("variantCurrentPrice", variantCurrentPrice);
    //  console.log("variantCurrentPriceFormated", variantCurrentPriceFormated);
    
    CurrentOrder();

    $(".vertical ul li a").click(function () {
      
        var frame_style = "Framed"
        // console.log("frame:::: click",frame_style )
        if (localStorage.Frame == 'No Frame') {
            frame_style = "UnFramed"
        }
        var degree = "2D"
        var selected_variant = degree + "-" + frame_style + "-Custom / " + localStorage.Size + " / 1-to-5"
        if (localStorage.TwoThree == "3D") {
            degree = "3DPrint-Sliced"
            selected_variant = degree + "-Custom / " + localStorage.Size + " / 1-to-5"
        }

        // console.log("Variant id", jQuery("#variantId").val());
        // console.log("allProductVariants[selected_variant", allProductVariants[selected_variant]);



        // jQuery("#variantId").val(allProductVariants[selected_variant].split(",")[0]);
        // jQuery("#product-price").text("$" + allProductVariants[selected_variant].split(",")[1]/100 + ".00")


        CurrentOrder()
    })
    $(".2d_3d_frame a").each(function () {
        $(this).click(function () {
            localStorage.setItem('Frame', $(this).text())
            CurrentOrder()
        })
    })



});

$(document).ready(function () {

// Function to show the modal
function showModal() {
  const myModalMessage = document.getElementById('myModalMessage');
  myModalMessage.style.display = "block";
  myModalMessage.classList.add('show');
  myModalMessage.classList.remove('hidemodal');
  myModalMessage.classList.remove('noshow');

}

// Function to close the modal
function closeModal() {
  const myModalMessage = document.getElementById('myModalMessage');
  myModalMessage.classList.add('hidemodal');
  myModalMessage.classList.remove('show');

  // myModalMessage.style.display = "none";
}

// Event listener for closing the modal when clicking the close button
document.querySelector('.message-close').addEventListener('click', closeModal);

// Check if the modal has been seen in the last 2 days
function checkModalVisibility() {
  const lastSeen = localStorage.getItem('modalLastSeen');
  const currentTime = new Date().getTime();
  const twoDaysInMilliseconds = 2 * 24 * 60 * 60 * 1000;

  if (!lastSeen || (currentTime - lastSeen > twoDaysInMilliseconds)) {
    // Show modal if not seen within 2 days
    showModal();
  } else {
    // Don't show the modal if seen within the last 2 days
   // console.log("Modal will not be shown as it was seen recently.");
  }
}

// Store the timestamp when the modal is shown
function onModalClose() {
  localStorage.setItem('modalLastSeen', new Date().getTime());
}

// Listen for the modal close event and store the timestamp
document.querySelector('.message-close').addEventListener('click', onModalClose);

window.onclick = function(event) {
  const myModalMessage = document.getElementById('myModalMessage');
  
  if (event.target == myModalMessage) {
    closeModal();

  }
}

// Run the modal visibility check when the page loads
window.onload = checkModalVisibility;

});


// $(document).ready(function () {
//     var messageModalTimeSet = localStorage.messageModalTime;
//     const currentDate = new Date();
//   console.log("messageModalTimeSet", localStorage.messageModalTime);
//   console.log("messageModalViewed", localStorage.messageModalViewed);


//   if(localStorage.messageModalViewed != "true" || localStorage.messageModalViewed != true || localStorage.messageModalViewed != "false" || localStorage.messageModalViewed != false ){
//     localStorage.setItem("messageModalViewed", "false");
//   }  
  
//     // reset after 2 days
//     // var timeReset = 172800000;

//     // Test few seconds
//     var timeReset = 30000;
//     const timeDifference = Date.now() - currentDate.getTime();
//     if ( timeDifference >= timeReset) {
//       // Clear localStorage
//       localStorage.setItem("messageModalViewed", "false");
//     }

    
//     // Get the modal
//     var myModalMessage = document.getElementById("myModalMessage");

//     console.log("myModalMessage", myModalMessage);

//     // Display modal if not seen
//     console.log("Display modal if not seen", localStorage.messageModalViewed);
  
//     if(localStorage.messageModalViewed == "true"){
      
//     } else if (localStorage.messageModalViewed == "false" ) {
//        console.log("localStorage.messageModalViewed", localStorage.messageModalViewed);
      
//        console.log("localStorage.messageModalViewed", localStorage.messageModalViewed == "false");
//       myModalMessage.style.display = "block";
//     }
    
  
//     // Get the <span> element that closes the modal
//     var span = document.getElementsByClassName("message-close")[0];

    
//     // When the user clicks on <span> (x), close the modal
//     span.onclick = function() {
//       myModalMessage.style.display = "none";
//       localStorage.setItem("messageModalViewed", "true");
//       localStorage.setItem("messageModalTime", Date.now());
      
//     }
    
//     // When the user clicks anywhere outside of the modal, close it
//     window.onclick = function(event) {
//       if (event.target == myModalMessage) {
//         myModalMessage.style.display = "none";
//        localStorage.setItem("messageModalViewed", "true");
//        localStorage.setItem("messageModalTime", Date.now());
//       }
//     }
// });
